import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import { useSelector, useDispatch } from 'react-redux';
import { SearchProjectAction, UpdateProjectAction } from '../../../redux/actions/project';
import { SEND_EMAIL_RESET } from '../../../redux/constantes/email';
import { UPDATE_PROJECT_RESET } from '../../../redux/constantes/project';

import { sendEmail } from '../../../functions/SincronizaNFe/sendEmail';

import { ContainerForm } from '../../../components/Containers';
import Title from '../../../components/SincronizaNFe/TitleSincroniza';
import InputRateio from '../../../components/SincronizaNFe/InputRateio';
import InputResultValue from '../../../components/SincronizaNFe/InputResultValue';
import SelectClientSincroniza from '../../../components/SincronizaNFe/SelectClientSincroniza';
import StatusBarHeader from '../../../components/SincronizaNFe/StatusBarHeader';
import { WrapperInputs } from '../../../components/SincronizaNFe/WrapperInputs';
import { WrapperButtons, ButtonFooter } from '../../../components/SincronizaNFe/WrapperButtonsAndFooter';
import { MessageBoxAlert, MessageBoxError, MessageBoxSuccess } from '../../../components/MessageBox';
import ButtonAddProject from '../../../components/SincronizaNFe/ButtonAddProject';
import ListProjects from '../../../components/SincronizaNFe/ListProjects';
import UploadFiles from '../../../components/SincronizaNFe/UploadFiles';
import ButtonBack from '../../../components/ButtonBack';
import InputTotalValue from '../../../components/SincronizaNFe/InputTotalValue';

export default function TemplateEditProject({ projectId }) {
  const [company, setCompany] = useState('');
  const [cnpj, setCnpj] = useState(0);
  const [clientAndProject, setClientAndProject] = useState('');
  const [rateio, setRateio] = useState(0);
  const [totalRateio, setTotalRateio] = useState(0);
  const [value, setValue] = useState(0);
  const [monthName, setMonthName] = useState('');
  const [thisYear, setThisYear] = useState('');
  const [totalValueCnpj1, setTotalValueCnpj1] = useState(0);
  const [totalValueCnpj2, setTotalValueCnpj2] = useState(0);
  const [totalValue, setTotalValue] = useState(0);
  const [totalValueStatus, setTotalValueStatus] = useState(0);
  const [files, setFiles] = useState([]);
  const [links, setLinks] = useState([]);
  const [filesEmpty, setFilesEmpty] = useState(true);
  const [projectAlert, setProjectAlert] = useState(false);
  const [duplicateProjectError, setDuplicateProjectError] = useState(false);
  const [anexoAlert, setAnexoAlert] = useState(false);
  const [sendAlert, setSendAlert] = useState(false);
  const [saveAlert, setSaveAlert] = useState(false);
  const [errorRateio, setErrorRateio] = useState(false);
  const [errorUploads, setErrorUploads] = useState(false);
  const [statusSecurity, setStatusSecurity] = useState(false);
  const [userSecurity, setUserSecurity] = useState('');

  const [projects, setProjects] = useState([]);

  const { userInfo, localFiles } = useSelector((state) => state.userSign);
  const { error: errorSearch, searchProject } = useSelector((state) => state.searchProject);
  const { error: erroUpdate, success: successUpdate } = useSelector((state) => state.updateProject);
  const { success: successEmail, error: errorEmail } = useSelector((state) => state.sendEmail);
  const dispatch = useDispatch();

  useEffect(() => {
    if (errorSearch === 'Token inválido') {
      localStorage.removeItem('userInfo');
      document.location.href = '/login';
    }
  }, [errorSearch]);

  useEffect(() => {
    if (successUpdate) {
      localStorage.removeItem('localFiles');
      setTimeout(() => {
        dispatch({ type: UPDATE_PROJECT_RESET });
        document.location.href = '/sincroniza-nfe';
      }, 2000);
    }
    if (successEmail) {
      setTimeout(() => {
        dispatch({ type: SEND_EMAIL_RESET });
      }, 2000);
    }
    if (errorEmail) {
      setTimeout(() => {
        dispatch({ type: SEND_EMAIL_RESET });
      }, 3000);
    }
    if (erroUpdate) {
      setTimeout(() => {
        dispatch({ type: UPDATE_PROJECT_RESET });
      }, 3000);
    }
    if (errorUploads) {
      setTimeout(() => {
        setErrorUploads(false);
      }, 10000);
    }
  }, [dispatch, successUpdate, successEmail, errorEmail, erroUpdate, errorUploads]);

  useEffect(() => {
    if (!searchProject) {
      dispatch(SearchProjectAction(projectId));
    } else {
      setMonthName(searchProject.monthName);
      setTotalValue(searchProject.totalValue);
      setTotalValueStatus(searchProject.totalValueStatus);
      setTotalValueCnpj1(searchProject.totalValueCnpj1);
      setTotalValueCnpj2(searchProject.totalValueCnpj2);
      setProjects(searchProject.project);
      setTotalRateio(searchProject.totalRateio);
      setThisYear(searchProject.year);
      setStatusSecurity(searchProject.status);
      setUserSecurity(searchProject.user);
    }
  }, [dispatch, projectId, searchProject]);

  useEffect(() => {
    setValue(isNaN(rateio) ? (0 * totalValue) / 100 : (rateio * totalValue) / 100);

    if (totalRateio > 100) {
      setErrorRateio(true);
    }
    if (totalRateio <= 100) {
      setErrorRateio(false);
    }
  }, [totalRateio, rateio, totalValue]);

  useEffect(() => {
    if (localFiles !== null) {
      if (filesEmpty) {
        setFiles(localFiles);
        setFilesEmpty(false);
      }
    }
  }, [localFiles, files, filesEmpty]);

  useEffect(() => {
    let linksDB = [];
    files.forEach((file) => {
      linksDB.push({ upload: file._id });
    });
    setLinks(linksDB);
  }, [files]);

  const handleSend = () => {
    sendEmail(userInfo, monthName, thisYear, totalValueCnpj1, totalValueCnpj2, totalValue, projects, files, dispatch);
    setTimeout(() => {
      dispatch(
        UpdateProjectAction(
          projectId,
          projects,
          true,
          userInfo._id,
          links,
          totalRateio,
          totalValueCnpj1,
          totalValueCnpj2,
          totalValueStatus,
          totalValue,
        ),
      );
    }, 250);
  };

  const handleSave = () => {
    dispatch(
      UpdateProjectAction(
        projectId,
        projects,
        false,
        userInfo._id,
        links,
        totalRateio,
        totalValueCnpj1,
        totalValueCnpj2,
        totalValueStatus,
        totalValue,
      ),
    );
  };
  return (
    <ContainerForm>
      {userInfo !== null && statusSecurity ? (
        <div>
          <MessageBoxError>Você já concluiu esse Faturamento!</MessageBoxError>
          <ButtonBack />
        </div>
      ) : errorSearch ? (
        <div>
          <MessageBoxError>Não conseguimos achar esse Faturamento!</MessageBoxError>
          <ButtonBack />
        </div>
      ) : userInfo !== null && userSecurity._id !== userInfo._id ? (
        <div>
          <MessageBoxError>Houve um erro!</MessageBoxError>
          <ButtonBack />
        </div>
      ) : (
        <div>
          <Title text="Apoio ao Faturamento do Prestador de Serviço" />
          <StatusBarHeader
            monthName={monthName}
            thisYear={thisYear}
            totalRateio={totalRateio}
            totalValueStatus={totalValueStatus}
            files={files}
            totalValueCnpj1={totalValueCnpj1}
            totalValueCnpj2={totalValueCnpj2}
          />
          <WrapperInputs>
            <InputTotalValue
              value={totalValue}
              setTotalValue={setTotalValue}
              disabled={projects.length >= 1 ? true : false}
            />
          </WrapperInputs>
          <WrapperInputs>
            <SelectClientSincroniza
              setCnpj={setCnpj}
              setClientAndProject={setClientAndProject}
              setCompany={setCompany}
              company={company}
            />
            <InputRateio rateio={rateio} setRateio={setRateio} />
            <InputResultValue value={value} />
            <ButtonAddProject
              cnpj={cnpj}
              setProjectAlert={setProjectAlert}
              company={company}
              clientAndProject={clientAndProject}
              rateio={rateio}
              value={value}
              setTotalValueCnpj1={setTotalValueCnpj1}
              setTotalValueCnpj2={setTotalValueCnpj2}
              totalValueCnpj1={totalValueCnpj1}
              totalValueCnpj2={totalValueCnpj2}
              setTotalRateio={setTotalRateio}
              totalRateio={totalRateio}
              setTotalValueStatus={setTotalValueStatus}
              setProjects={setProjects}
              setCompany={setCompany}
              setRateio={setRateio}
              setValue={setValue}
              projects={projects}
              setDuplicateProjectError={setDuplicateProjectError}
              monthName={monthName}
            />
          </WrapperInputs>
          <ListProjects
            projects={projects}
            setProjects={setProjects}
            setTotalRateio={setTotalRateio}
            setTotalValueStatus={setTotalValueStatus}
            setTotalValueCnpj1={setTotalValueCnpj1}
            totalValueCnpj1={totalValueCnpj1}
            setTotalValueCnpj2={setTotalValueCnpj2}
            totalValueCnpj2={totalValueCnpj2}
          />
          <UploadFiles
            files={files}
            setFiles={setFiles}
            userInfo={userInfo}
            totalRateio={totalRateio}
            setAnexoAlert={setAnexoAlert}
            setErrorUploads={setErrorUploads}
          />
          <WrapperButtons>
            <Link to="/sincroniza-nfe">Voltar</Link>
            <ButtonFooter
              color="#B29446"
              onClick={handleSave}
              onMouseEnter={() => setSaveAlert(true)}
              onMouseLeave={() => setSaveAlert(false)}
              disabled={
                monthName === 'Selecione um mês' ||
                monthName === 'Nenhum mês selecionado' ||
                totalRateio > 100 ||
                projects.length === 0 ||
                files.length > 0
                  ? true
                  : false
              }
            >
              Salvar Rascunho
            </ButtonFooter>
            <ButtonFooter
              color="#46B285"
              onClick={handleSend}
              onMouseEnter={() => setSendAlert(true)}
              onMouseLeave={() => setSendAlert(false)}
              disabled={
                monthName === 'Selecione um mês' ||
                monthName === 'Nenhum mês selecionado' ||
                totalRateio !== 100 ||
                files.length === 0 ||
                files.length > 10
                  ? true
                  : false
              }
            >
              Enviar
            </ButtonFooter>
          </WrapperButtons>
          {successUpdate && <MessageBoxSuccess>Seu faturamento foi cadastrado com sucesso!</MessageBoxSuccess>}
          {successEmail && <MessageBoxSuccess>Faturamento enviado por email com sucesso!</MessageBoxSuccess>}
          {erroUpdate && <MessageBoxError>{erroUpdate}</MessageBoxError>}
          {errorEmail && <MessageBoxError>{errorEmail}</MessageBoxError>}
          {errorRateio && <MessageBoxError>Atenção: Seu rateio esta acima 100%.</MessageBoxError>}
          {errorUploads && (
            <MessageBoxError>
              Atenção: Você excedeu a quantidade máxima de 10 itens anexados OU um de seus itens ultrapassa o tamanho de
              10mb OU o item não é do formato .PDF.
            </MessageBoxError>
          )}
          {files.length > 10 && (
            <MessageBoxError>Atenção: Você excedeu a quantidade máxima de 10 itens anexados.</MessageBoxError>
          )}
          {duplicateProjectError && <MessageBoxError>Ops... Você já selecionou este projeto</MessageBoxError>}
          {projectAlert && <MessageBoxAlert>Ops... Você não selecionou um projeto</MessageBoxAlert>}
          {anexoAlert && (
            <MessageBoxAlert>O anexo apenas será habilitado após completar 100% do rateio.</MessageBoxAlert>
          )}
          {anexoAlert && <MessageBoxAlert>Atenção¹: Você pode anexar no máximo 10 itens de 10MB.</MessageBoxAlert>}
          {anexoAlert && (
            <MessageBoxAlert>
              Atenção²: Apenas faça o anexo dos itens quando for enviar de forma definitiva.
            </MessageBoxAlert>
          )}
          {saveAlert && (
            <MessageBoxAlert>
              Ao salvar como rascunho, os itens não serão anexados, então apenas faça o anexo quando for enviar de forma
              definitiva.
            </MessageBoxAlert>
          )}
          {sendAlert && (
            <MessageBoxAlert>
              Apenas envie quando concluir o rateio em 100% e anexar Nota Fiscal e/ou boleto. <br />
              Após o envio, você não poderá mais alterar ou anexar arquivos, então tome cuidado!
            </MessageBoxAlert>
          )}
        </div>
      )}
    </ContainerForm>
  );
}
